const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3Browser {
    constructor(runtime) { this.runtime = runtime; }
    getInfo() {
        return {
            id: 'browserExt', name: '🌐 ブラウザ', color1: '#4ECDC4', color2: '#3DB5AC',
            blocks: [
                { opcode: 'url', blockType: BlockType.REPORTER, text: '現在のURL' },
                { opcode: 'ua', blockType: BlockType.REPORTER, text: 'ユーザーエージェント' },
                { opcode: 'lang', blockType: BlockType.REPORTER, text: '言語' },
                { opcode: 'online', blockType: BlockType.BOOLEAN, text: 'オンライン？' },
                { opcode: 'width', blockType: BlockType.REPORTER, text: '画面の幅' },
                { opcode: 'height', blockType: BlockType.REPORTER, text: '画面の高さ' },
                { opcode: 'open', blockType: BlockType.COMMAND, text: 'URL [U] を開く', arguments: { U: { type: ArgumentType.STRING, defaultValue: 'https://scratch.mit.edu' } } },
                { opcode: 'copy', blockType: BlockType.COMMAND, text: '[T] をコピー', arguments: { T: { type: ArgumentType.STRING, defaultValue: 'Hello' } } },
                { opcode: 'alert', blockType: BlockType.COMMAND, text: 'アラート [M]', arguments: { M: { type: ArgumentType.STRING, defaultValue: 'Hello!' } } }
            ]
        };
    }
    url() { return window.location.href; }
    ua() { return navigator.userAgent; }
    lang() { return navigator.language; }
    online() { return navigator.onLine; }
    width() { return window.innerWidth; }
    height() { return window.innerHeight; }
    open(args) { window.open(Cast.toString(args.U), '_blank'); }
    copy(args) { try { navigator.clipboard.writeText(Cast.toString(args.T)); } catch(e) {} }
    alert(args) { window.alert(Cast.toString(args.M)); }
}
module.exports = Scratch3Browser;